export default {
  bind(el) {
    el.setAttribute('data-pdf-chart-group', '');
  },
};
